var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgILinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C4670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.625 12.375C27.2227 12.375 27.75 12.9023 27.75 13.5352V27C27.75 27.6328 27.2227 28.125 26.625 28.125H13.0898C12.4922 28.125 12 27.6328 12 27V13.5352C12 12.9023 12.4922 12.375 13.0898 12.375H26.625ZM16.7461 25.875V18.3867H14.4258V25.875H16.7461ZM15.5859 17.332C16.3242 17.332 16.9219 16.7344 16.9219 15.9961C16.9219 15.2578 16.3242 14.625 15.5859 14.625C14.8125 14.625 14.2148 15.2578 14.2148 15.9961C14.2148 16.7344 14.8125 17.332 15.5859 17.332ZM25.5 25.875V21.7617C25.5 19.7578 25.043 18.1758 22.6875 18.1758C21.5625 18.1758 20.7891 18.8086 20.4727 19.4062H20.4375V18.3867H18.2227V25.875H20.543V22.1836C20.543 21.1992 20.7188 20.25 21.9492 20.25C23.1445 20.25 23.1445 21.375 23.1445 22.2188V25.875H25.5Z",
    fill: "#0689FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgILinkedin);
export default __webpack_public_path__ + "static/media/i-linkedin.7d3655b2e6ae404b026185e9fa9c6d2c.svg";
export { ForwardRef as ReactComponent };